import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  getMyApprovals(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/dashboard/get_approvals`
    );
  }
  getAttendanceReguarisationRequest(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/dashboard/get_attendance_reguarisation_request`
    );
  }
  mrfApprovalAction(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/mrf_approve_action`,
      req
    );
  }
  getEmpAssistance(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/dashboard/get_emp_assistance_content`
    );
  }
  regulariseApprove(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/regularise_approve`,
      req
    );
  }

  bulkMrfApprovalAction(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/bulk_mrf_approve_action`,
      req
    );
  }
  bulkExitApprovalAction(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/bulk_exit_approve_action`,
      req
    );
  }
  exitMgmt(emId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/exit_management/` + emId
    );
  }
  exitMgmtNo(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/exit_management_no`
    );
  }
  selectEmp(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_master_user`);
  }
  getMyReporties(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_my_reporties`);
  }
  addExitEmp(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/add_exit_management`,
      req
    );
  }

  // exit on behalf role

  onBehalfRoles(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/helpdesk/exit_onbehalf_role`
    );
  }

  getEmoIdCard(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_employee_idcard`);
  }

  getOptions(gpId): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_options/` + gpId);
  }
  getReasonsOption(vlID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_vltry_reason/` + vlID
    );
  }
  getModOptions(gpId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_options_mod/` + gpId
    );
  }

  addEmpIdCard(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrlsdx}/employee/add_emp_idcard`,
      req
    );
  }

  exitApprovalAction(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/exit_approve_action`,
      req
    );
  }

  getNewJoiningList(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/dashboard/get_new_joinigs`
    );
  }
  // getNewJoiningList(data): Observable<any[]>{
  //   let param = new HttpParams();
  //   for (const key in data.forms) {
  //     if (data.forms[key] !== '' && data.forms[key] !== undefined && data.forms[key] !== null) {
  //       param = param.append(key, data.forms[key]);
  //     }
  //   }
  //   return this.http.get<any[]>(`${environment.apiUrl}/dashboard/get_new_joinigs`, { params: param});
  // }

  // let param = new HttpParams();
  //   for (const key in data.forms) {
  //     if (data.forms[key] !== '' && data.forms[key] !== undefined && data.forms[key] !== null) {
  //       param = param.append(key, data.forms[key]);
  //     }
  //   }
  // Leaves

  getLeaveData(from, to): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_leave?self=self&date_from=${from}&date_to=${to}`
    );
  }

  getLeaveDataEmp(from, to, emp_id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_leave?emp_id=${emp_id}&date_from=${from}&date_to=${to}`
    );
  }

  getLeaveType(userId: string = ''): Observable<any[]> {
    let param = new HttpParams();
    if (userId !== '') {
      param = param.append('user', userId);
    }

    return this.http.get<any[]>(
      `${environment.apiUrl}/leaves/get_jobcat_leave_type`,
      { params: param }
    );
  }

  addleave(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/add_leave_action`,
      data
    );
  }

  aprrovalLeaveGet(data): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/dashboard/get_leave_admin?page=${data.page}&limit=${data.limit}&is_approve=${data.is_approve}`
    );
  }

  approveRejLeave(status, lvId, remarks): Observable<any> {
    const option = {
      is_approved: status,
      lv_id: lvId,
      remark: remarks,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/dashboard/leave_approved_action`,
      options
    );
  }

  // emp clearance chklist
  getClearanceChklist(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/emp_exit_clearance_checklist`,
      req
    );
  }

  addClearanceChklist(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/save_emp_exit_clearance_checklist`,
      data
    );
  }
  finishClearanceChklist(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/check_emp_exit_clearance_checklist`,
      req
    );
  }
  checkEmpExitStatus(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/check_emp_exit_status`
    );
  }

  getLoggedInEmpDetails(): Observable<any> {
      return this.http.get<any[]>(`${environment.apiUrl}/loggedin_emp_detail`);
  }
  getLoggedInEmpDetailsBm(id): Observable<any> {
    if(id==null)
    {
      return this.http.get<any[]>(`${environment.apiUrl}/loggedin_emp_detail`);
    }
    else
    {
      return this.http.get<any[]>(`${environment.apiUrl}/emp_id_detail/${id}`);
    }
  }

  getLoggedInEmpDetailsNews(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/loggedin_emp_detail_news`);
  }
 
  EmpDetailswithID(empID): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/emp_id_detail/${empID}`);
  }

  // award approval

  awardApproveAction(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/award_approve_action`,
      data
    );
  }

  // b'Day & Work anniversary

  sendBdayWish(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/sent_emp_birthday_wish`,
      data
    );
  }

  getEmpBday(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/dashboard/get_emp_birthday_today`
    );
  }
  getEmpWrkAnnivrsry(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/dashboard/get_emp_work_anniversary`
    );
  }
  idCardApproveAction(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/id_card_approve_action`,
      data
    );
  }
  bulkIDCardApprovalAction(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/bulk_id_card_approve_action`,
      data
    );
  }
  //  idCardApprovalAction

  // epa Approve
  epaApproveAction(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/epa_approve_action`,
      data
    );
  }

  epaBulkApproveAction(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/bulk_epa_approve_action`,
      data
    );
  }

  // pettycash Approvals

  pettyCashApproveAction(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/pettyCash_approve_action`,
      data
    );
  }

  pettyCashExpenseApproveAction(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/pettyCash_expense_approve_action`,
      data
    );
  }

  pettyCashBulkApproveAction(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/bulk_pettyCash_approve_action`,
      data
    );
  }

  //  workplace permission approval

  workplaceApproveAction(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/approve_work_place_action`,
      data
    );
  }

  // covid19 Questions

  covidQues(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/policy/get_covdquestion`
    );
  }

  addWorkplacepermissio(data: FormData): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/policy/add_wrk_permission`,
      data
    );
  }

  permissionReport(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/policy/get_work_permission`
    );
  }
  vacinDeclareReport(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/policy/report_vaccin_declare`
    );
  }
  pendingVacinDeclareReport(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/covid/get_pending_vacc_users`
    );
  }

  addVaccineDetail(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/policy/add_vaccine_declare`,
      data
    );
  }

  bulUploadVaccData(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/policy/add_vaccin_through_excel`,
      data
    );
  }

  vaccineDataGet(userID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/policy/get_vaccine_declare?user_id=${userID}`
    );
  }

  onboardedEmployeeDeatils(empID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_onboarded_employee_detail/` + empID
    );
  }

  // Approvals

  expenseApprove(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/expense_approve_action`,
      data
    );
  }

  expenseBulkApprove(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/bulk_expense_approve_action`,
      data
    );
  }

  getPCByCode(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/buddy/get_pcs_site_manager_buddy`,
      data
    );
  }

  //  exit updatemodal
  exitUpdate(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/exit_rgn_update`,
      data
    );
  }

  //  idcards

  empIDCardDetails(empID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_logged_emp_id_card?emp_id=` + empID
    );
  }

  employeeApprovals(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/dashboard/employee_approvals`
    );
  }

  addEmpVstngCard(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/employee/add_emp_vstng_card`,
      req
    );
  }

  empVstngCardDetails(empID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/logged_emp_vstng_card?emp_id=` + empID
    );
  }

  visitCardApproveAction(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/vst_card_approve_action`,
      data
    );
  }

  bulkVisitingCardApprovalAction(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/bulk_vst_card_approve_action`,
      data
    );
  }

  ongcApproveAction(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/ongc_pass_approve_action`,
      data
    );
  }

  baseOfficeAddressList(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/address_drop_down`
    );
  }
  napsMrfApprovalAction(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/naps_mrf_approve_action`,
      req
    );
  }

  getExitMod(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/get_exit_mod`, {
      params: param,
    });
  }

  getExitReasonsOption(data: any): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_exit_vltry_reason`,
      { params: param }
    );
  }

  getRefineFiles(data: any): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/get_refyne_app_data`, {
      params: param,
    });
  }

  getRefineLang(catID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/get_refyne_language/` + catID
    );
  }

  getRefyneAppLabel(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/get_refyne_app_text`);
  }

  awardsForDashbord(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/kudos/get_award_for_dashboard`,
      { params: param }
    );
  }

  likeUnlike(data): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/kudos/like_unlike_award`,
      data
    );
  }

  commentAction(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}/kudos/do_comment`, data);
  }

  likeUnlikeNews(data): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/communication/news/like_unlike_news`,
      data
    );
  }

  commentActionNews(data): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/communication/news/do_comment`,
      data
    );
  }

  getNewJoinings(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/dashboard/get_emp_new_joining`
    );
  }

  sendAnniversaryWish(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/sent_emp_anniversary_wish`,
      data
    );
  }

  sendOnboardWish(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/dashboard/sent_emp_joining_wish`,
      data
    );
  }

  getHotJobs(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/talent/mrf/get_hot_jobs`);
  }

  ideaCommtdApproveAction(data):Observable<any>{
    return this.http.post<any[]>(`${environment.apiUrl}/cross-selling/approve_idea_by_committe`,data);

  }

}
